"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumber = void 0;
var format_number_1 = require("./format-number");
Object.defineProperty(exports, "formatNumber", { enumerable: true, get: function () { return format_number_1.formatNumber; } });
